export const AVOCATION_QUESTIONS_DATA_REQUEST =
  'AVOCATION_QUESTIONS_DATA_REQUEST';
export const AVOCATION_QUESTIONS_DATA_SUCCESS =
  'AVOCATION_QUESTIONS_DATA_SUCCESS';
export const AVOCATION_QUESTIONS_DATA_FAIL = 'AVOCATION_QUESTIONS_DATA_FAIL';
